import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '@/components/pages/Login'
import FirstLogin from '@/components/pages/FirstLogin'
import Scout from '@/components/pages/scouts/Scout'
import ScoutTop from '@/components/pages/scouts/ScoutTop'
import ScoutSearch from '@/components/pages/scouts/ScoutSearch'
import ScoutSearchResult from '@/components/pages/scouts/ScoutSearchResult'
import ScoutContents from '@/components/templates/ScoutContents'
import ScoutCandidate from '@/components/pages/scouts/ScoutCandidate'
import ScoutExcluded from '@/components/pages/scouts/ScoutExcluded'
import ScoutCreate from '@/components/pages/scouts/ScoutCreate'
import ScoutScouted from '@/components/pages/scouts/ScoutScouted'
import ScoutRecommended from '@/components/pages/scouts/ScoutRecommended'
import ScoutReservation from '@/components/pages/scouts/ScoutReservation'
import Entry from '@/components/pages/entry/Entry'
import EntryTop from '@/components/pages/entry/EntryTop'
import EntryBulkMessage from '@/components/pages/entry/EntryBulkMessage'
import EntryDetail from '@/components/pages/entry/EntryDetail'
import EntryPrintPreview from '@/components/pages/entry/EntryPrintPreview'
import RealIntention from '@/components/pages/realintention/RealIntention'
import RealIntentionTop from '@/components/pages/realintention/RealIntentionTop'
import RealIntentionRegisterOrEdit from '@/components/pages/realintention/RealIntentionRegisterOrEdit'
import RealIntentionPreviewPc from '@/components/pages/realintention/RealIntentionPreviewPc'
import RealIntentionPreviewSp from '@/components/pages/realintention/RealIntentionPreviewSp'
import InterviewInformation from '@/components/pages/interview-information/InterviewInformation'
import InterviewCandidateDate from '@/components/pages/interview-candidate-date/InterviewCandidateDate'
import InterviewCandidateDateTop from '@/components/pages/interview-candidate-date/InterviewCandidateDateTop'
import InterviewCandidateDateEdit from '@/components/pages/interview-candidate-date/InterviewCandidateDateEdit'
import InterviewInformationRegisterOrEdit from '@/components/pages/interview-information/InterviewInformationRegisterOrEdit'
import InterviewInformationPreview from '@/components/pages/interview-information/InterviewInformationPreview'
import InterviewInformationTop from '@/components/pages/interview-information/InterviewInformationTop'
import Job from '@/components/pages/jobs/Job'
import JobPrePublished from '@/components/pages/jobs/JobPrePublished'
import JobPrePublishedPreview from '@/components/pages/jobs/JobPrePublishedPreview'
import JobPreviewSp from '@/components/pages/jobs/JobPreviewSp'
import CompanyPreview from '@/components/pages/jobs/CompanyPreview'
import CompanyPreviewSp from '@/components/pages/jobs/CompanyPreviewSp'
import PhotoClipPreview from '@/components/pages/jobs/PhotoClipPreview'
import PhotoClipPreviewSp from '@/components/pages/jobs/PhotoClipPreviewSp'
import InterviewPreview from '@/components/pages/jobs/InterviewPreview'
import InterviewPreviewSp from '@/components/pages/jobs/InterviewPreviewSp'
import JobSearchPreview from '@/components/pages/jobs/JobSearchPreview'
import JobSearchPreviewSp from '@/components/pages/jobs/JobSearchPreviewSp'
import JobPublished from '@/components/pages/jobs/JobPublished'
import JobPublishedPreview from '@/components/pages/jobs/JobPublishedPreview'
import SeminarEntry from '@/components/pages/seminar/SeminarEntry'
import SeminarEntryTop from '@/components/pages/seminar/SeminarEntryTop'
import SeminarEntryBulkMessage from '@/components/pages/seminar/SeminarEntryBulkMessage'
import SeminarEntryDetail from '@/components/pages/seminar/SeminarEntryDetail'
import Setting from '@/components/templates/Setting'
import SettingMemberAttributes from '@/components/pages/settings/SettingMemberAttributes'
import SettingScoutTemplates from '@/components/pages/settings/SettingScoutTemplates'
import SettingAccounts from '@/components/pages/settings/SettingAccounts'
import SettingAccountPassword from '@/components/pages/settings/SettingAccountPassword'
import SettingScoutTemplateRegister from '@/components/pages/settings/SettingScoutTemplateRegister'
import SettingScoutTemplateEdit from '@/components/pages/settings/SettingScoutTemplateEdit'
import SettingMessageTemplates from '@/components/pages/settings/SettingMessageTemplates'
import SettingMessageTemplateRegister from '@/components/pages/settings/SettingMessageTemplateRegister'
import SettingMessageTemplateEdit from '@/components/pages/settings/SettingMessageTemplateEdit'
import SettingAccountRegister from '@/components/pages/settings/SettingAccountRegister'
import SettingAccountEdit from '@/components/pages/settings/SettingAccountEdit'
import SettingIpAddress from '@/components/pages/settings/SettingIpAddress'
import SettingEntryColumns from '@/components/pages/settings/SettingEntryColumns'
import SettingSelections from '@/components/pages/settings/SettingSelections'
import SettingEntryAutoReply from '@/components/pages/settings/SettingEntryAutoReply'
import Dashboard from '@/components/pages/dashboard/Dashboard'
import DashboardTop from '@/components/pages/dashboard/DashboardTop'
import Dummy from '@/components/pages/dummy/Dummy'
import DummyTop from '@/components/pages/dummy/DummyTop'
import NotFound from '@/components/pages/NotFound'
import InternalServerError from '@/components/pages/InternalServerError'
import SettingAccountMail from '@/components/pages/settings/SettingAccountMail'

Vue.use(VueRouter)

export default new VueRouter({
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/scouts',
      component: Scout,
      children: [
        {
          path: '',
          name: 'scoutTop',
          component: ScoutTop
        },
        {
          path: 'excluded_members',
          name: 'scoutExcluded',
          component: ScoutExcluded
        },
        {
          path: 'contracts/:contractId/jobs/:jobId/users',
          name: 'scoutContents',
          component: ScoutContents,
          children: [
            {
              path: 'search',
              name: 'scoutSearch',
              component: ScoutSearch,
              props: true
            },
            {
              path: 'search_results',
              name: 'scoutSearchResult',
              component: ScoutSearchResult
            },
            {
              path: 'candidate',
              name: 'scoutCandidate',
              component: ScoutCandidate
            },
            {
              path: 'create',
              name: 'scoutCreate',
              component: ScoutCreate,
              props: true
            },
            {
              path: 'scouted',
              name: 'scoutScouted',
              component: ScoutScouted
            },
            {
              path: 'recommended',
              name: 'scoutRecommended',
              component: ScoutRecommended
            },
            {
              path: 'reservations',
              name: 'scoutReservation',
              component: ScoutReservation
            },
            {
              path: 'reservations/:reservationId',
              name: 'scoutCreateReservation',
              component: ScoutCreate,
              props: true
            }
          ]
        }
      ]
    },
    {
      path: '/entries',
      component: Entry,
      children: [
        {
          path: '',
          name: 'entryTop',
          component: EntryTop
        },
        {
          path: 'bulk_message',
          name: 'entryBulkMessage',
          component: EntryBulkMessage,
          props: true
        },
        {
          path: ':entryId',
          name: 'entryDetail',
          component: EntryDetail,
          props: true
        }
      ]
    },
    {
      path: '/seminar_entries',
      component: SeminarEntry,
      children: [
        {
          path: '',
          name: 'seminarEntryTop',
          component: SeminarEntryTop
        },
        {
          path: 'bulk_message',
          name: 'seminarEntryBulkMessage',
          component: SeminarEntryBulkMessage,
          props: true
        },
        {
          path: ':entryId',
          name: 'seminarEntryDetail',
          component: SeminarEntryDetail,
          props: true
        }]
    },
    {
      path: '/entries/:entryId/print_preview',
      name: 'entryPrintPreview',
      component: EntryPrintPreview
    },
    {
      path: '/real_intentions',
      component: RealIntention,
      children: [
        {
          path: '',
          name: 'realIntentionTop',
          component: RealIntentionTop
        },
        {
          path: 'register',
          name: 'realIntentionRegister',
          component: RealIntentionRegisterOrEdit
        },
        {
          path: ':realIntentionId/edit/',
          name: 'realIntentionEdit',
          component: RealIntentionRegisterOrEdit
        }
      ]
    },
    {
      path: '/real_intentions/preview/pc/:id',
      name: 'realIntentionPreviewPc',
      component: RealIntentionPreviewPc
    },
    {
      path: '/real_intentions/preview/sp/:id',
      name: 'realIntentionPreviewSp',
      component: RealIntentionPreviewSp
    },
    {
      path: '/interview_information',
      component: InterviewInformation,
      children: [
        {
          path: '',
          name: 'interviewInformationTop',
          component: InterviewInformationTop
        },
        {
          path: 'register',
          name: 'interviewInformationRegister',
          component: InterviewInformationRegisterOrEdit
        }, {
          path: ':jobInterviewId',
          name: 'interviewInformationEdit',
          component: InterviewInformationRegisterOrEdit
        }
      ]
    },
    {
      path: '/interview_information/:jobInterviewId/preview',
      name: 'interviewInformationPreview',
      component: InterviewInformationPreview
    },
    {
      path: '/interview_candidates',
      component: InterviewCandidateDate,
      children: [
        {
          path: '',
          name: 'interviewCandidateDateTop',
          component: InterviewCandidateDateTop
        },
        {
          path: ':id',
          name: 'interviewCandidateDateEdit',
          component: InterviewCandidateDateEdit
        }
      ]
    },
    {
      path: '/job_confirmation',
      component: Job,
      children: [
        {
          path: 'pre_published',
          name: 'jobPrePublished',
          component: JobPrePublished
        },
        {
          path: 'published',
          name: 'jobPublished',
          component: JobPublished
        }
      ]
    },
    {
      path: '/job_confirmation/pre_published/preview/:jobId',
      name: 'jobPrePublishedPreview',
      component: JobPrePublishedPreview
    },
    {
      path: '/job_confirmation/pre_published/preview_sp/:jobId',
      name: 'jobPrePublishedPreviewSp',
      component: JobPreviewSp
    },
    {
      path: '/job_confirmation/published/preview/:offerId',
      name: 'jobPublishedPreview',
      component: JobPublishedPreview
    },
    {
      path: '/job_confirmation/published/preview_sp/:offerId',
      name: 'jobPublishedPreviewSp',
      component: JobPreviewSp
    },
    {
      path: '/job_confirmation/pre_published/search_preview/:jobId',
      name: 'jobSearchPrePublishedPreview',
      component: JobSearchPreview
    },
    {
      path: '/job_confirmation/pre_published/search_preview_sp/:jobId',
      name: 'jobSearchPrePublishedPreviewSp',
      component: JobSearchPreviewSp
    },
    {
      path: '/job_confirmation/published/search_preview/:offerId',
      name: 'jobSearchPublishedPreview',
      component: JobSearchPreview
    },
    {
      path: '/job_confirmation/published/search_preview_sp/:offerId',
      name: 'jobSearchPublishedPreviewSp',
      component: JobSearchPreviewSp
    },
    {
      path: '/job_confirmation/pre_published/photoclip_preview/:id',
      name: 'photoClipPrePublishedPreview',
      component: PhotoClipPreview
    },
    {
      path: '/job_confirmation/pre_published/photoclip_preview_sp/:id',
      name: 'photoClipPrePublishedPreviewSp',
      component: PhotoClipPreviewSp
    },
    {
      path: '/job_confirmation/published/photoclip_preview/:id',
      name: 'photoClipPublishedPreview',
      component: PhotoClipPreview
    },
    {
      path: '/job_confirmation/published/photoclip_preview_sp/:id',
      name: 'photoClipPublishedPreviewSp',
      component: PhotoClipPreviewSp
    },
    {
      path: '/job_confirmation/pre_published/interview_preview/:id',
      name: 'interviewPrePublishedPreview',
      component: InterviewPreview
    },
    {
      path: '/job_confirmation/pre_published/interview_preview_sp/:id',
      name: 'interviewPrePublishedPreviewSp',
      component: InterviewPreviewSp
    },
    {
      path: '/job_confirmation/published/interview_preview/:id',
      name: 'interviewPublishedPreview',
      component: InterviewPreview
    },
    {
      path: '/job_confirmation/published/interview_preview_sp/:id',
      name: 'interviewPublishedPreviewSp',
      component: InterviewPreviewSp
    },
    {
      path: '/job_confirmation/pre_published/company_preview/:id',
      name: 'companyPrePublishedPreview',
      component: CompanyPreview
    },
    {
      path: '/job_confirmation/pre_published/company_preview_sp/:id',
      name: 'companyPreviewSp',
      component: CompanyPreviewSp
    },
    {
      path: '/settings',
      name: 'settings',
      component: Setting,
      children: [
        {
          path: 'member_attributes',
          name: 'settingMemberAttributes',
          component: SettingMemberAttributes
        },
        {
          path: 'accounts',
          name: 'settingAccounts',
          component: SettingAccounts
        },
        {
          path: 'accounts/:id',
          name: 'settingAccountEdit',
          component: SettingAccountEdit
        },
        {
          path: 'account_register',
          name: 'settingAccountRegister',
          component: SettingAccountRegister
        },
        {
          path: 'account_password',
          name: 'settingAccountPassword',
          component: SettingAccountPassword
        },
        {
          path: 'account_mail',
          name: 'settingAccountMail',
          component: SettingAccountMail
        },
        {
          path: 'scout_templates',
          name: 'settingScoutTemplates',
          component: SettingScoutTemplates
        },
        {
          path: 'scout_template_register',
          name: 'settingScoutTemplateRegister',
          component: SettingScoutTemplateRegister
        },
        {
          path: 'scout_templates/:id',
          name: 'settingScoutTemplateEdit',
          component: SettingScoutTemplateEdit
        },
        {
          path: 'message_templates',
          name: 'settingMessageTemplates',
          component: SettingMessageTemplates
        },
        {
          path: 'message_template_register',
          name: 'settingMessageTemplateRegister',
          component: SettingMessageTemplateRegister
        },
        {
          path: 'message_templates/:id',
          name: 'settingMessageTemplateEdit',
          component: SettingMessageTemplateEdit
        },
        {
          path: 'ip',
          name: 'settingIpAddress',
          component: SettingIpAddress
        },
        {
          path: 'entry_columns',
          name: 'settingEntryColumns',
          component: SettingEntryColumns
        },
        {
          path: 'selections',
          name: 'settingSelections',
          component: SettingSelections
        },
        {
          path: 'entry_auto_reply',
          name: 'settingEntryAutoReply',
          component: SettingEntryAutoReply
        }
      ]
    },
    {
      path: '/dashboard',
      component: Dashboard,
      children: [
        {
          path: '',
          name: 'dashboardTop',
          component: DashboardTop
        }
      ]
    },
    {
      path: '/first_login',
      component: FirstLogin
    },
    {
      path: '/dummy',
      component: Dummy,
      children: [
        {
          path: '',
          name: 'dummyTop',
          component: DummyTop
        }
      ]
    },
    {
      path: '*',
      component: NotFound
    },
    {
      path: '/500',
      component: InternalServerError
    },
    {
      path: '/boss_s/job_confirmation/preview/editing/company/:companyId/jobs/:jobId',
      name: 'bossSPrePublishedEditingJobPreview',
      component: JobPrePublishedPreview
    },
    {
      path: '/boss_s/job_confirmation/preview_sp/editing/company/:companyId/jobs/:jobId',
      name: 'bossSPrePublishedEditingJobPreviewSp',
      component: JobPreviewSp
    },
    {
      path: '/boss_s/job_confirmation/preview/confirm/company/:companyId/jobs/:jobId',
      name: 'bossSPrePublishedConfirmJobPreview',
      component: JobPrePublishedPreview
    },
    {
      path: '/boss_s/job_confirmation/preview_sp/confirm/company/:companyId/jobs/:jobId',
      name: 'bossSPrePublishedConfirmJobPreviewSp',
      component: JobPreviewSp
    },
    {
      path: '/boss_s/job_confirmation/preview/published/company/:companyId/jobs/:offerId',
      name: 'bossSPublishedJobPreview',
      component: JobPublishedPreview
    },
    {
      path: '/boss_s/job_confirmation/preview_sp/published/company/:companyId/jobs/:offerId',
      name: 'bossSPublishedJobPreviewSp',
      component: JobPreviewSp
    },
    {
      path: '/boss_s/job_confirmation/search_preview/editing/company/:companyId/jobs/:jobId',
      name: 'bossSPrePublishedEditingJobSearchPreview',
      component: JobSearchPreview
    },
    {
      path: '/boss_s/job_confirmation/search_preview_sp/editing/company/:companyId/jobs/:jobId',
      name: 'bossSPrePublishedEditingJobSearchPreviewSp',
      component: JobSearchPreviewSp
    },
    {
      path: '/boss_s/job_confirmation/search_preview/confirm/company/:companyId/jobs/:jobId',
      name: 'bossSPrePublishedConfirmJobSearchPreview',
      component: JobSearchPreview
    },
    {
      path: '/boss_s/job_confirmation/search_preview_sp/confirm/company/:companyId/jobs/:jobId',
      name: 'bossSPrePublishedConfirmJobSearchPreviewSp',
      component: JobSearchPreviewSp
    },
    {
      path: '/boss_s/job_confirmation/photoclip_preview/editing/company/:companyId/photoclips/:id',
      name: 'bossSPrePublishedEditingPhotoClipPreview',
      component: PhotoClipPreview
    },
    {
      path: '/boss_s/job_confirmation/photoclip_preview_sp/editing/company/:companyId/photoclips/:id',
      name: 'bossSPrePublishedEditingPhotoClipPreviewSp',
      component: PhotoClipPreviewSp
    },
    {
      path: '/boss_s/job_confirmation/photoclip_preview/confirm/company/:companyId/photoclips/:id',
      name: 'bossSPrePublishedConfirmPhotoClipPreview',
      component: PhotoClipPreview
    },
    {
      path: '/boss_s/job_confirmation/photoclip_preview_sp/confirm/company/:companyId/photoclips/:id',
      name: 'bossSPrePublishedConfirmPhotoClipPreviewSp',
      component: PhotoClipPreviewSp
    },
    {
      path: '/boss_s/job_confirmation/photoclip_preview/published/company/:companyId/photoclips/:id',
      name: 'bossSPublishedPhotoClipPreview',
      component: PhotoClipPreview
    },
    {
      path: '/boss_s/job_confirmation/photoclip_preview_sp/published/company/:companyId/photoclips/:id',
      name: 'bossSPublishedPhotoClipPreviewSp',
      component: PhotoClipPreviewSp
    },
    {
      path: '/boss_s/job_confirmation/interview_preview/editing/company/:companyId/interviews/:id',
      name: 'bossSPrePublishedEditingInterviewPreview',
      component: InterviewPreview
    },
    {
      path: '/boss_s/job_confirmation/interview_preview_sp/editing/company/:companyId/interviews/:id',
      name: 'bossSPrePublishedEditingInterviewPreviewSp',
      component: InterviewPreviewSp
    },
    {
      path: '/boss_s/job_confirmation/interview_preview/confirm/company/:companyId/interviews/:id',
      name: 'bossSPrePublishedConfirmInterviewPreview',
      component: InterviewPreview
    },
    {
      path: '/boss_s/job_confirmation/interview_preview_sp/confirm/company/:companyId/interviews/:id',
      name: 'bossSPrePublishedConfirmInterviewPreviewSp',
      component: InterviewPreviewSp
    },
    {
      path: '/boss_s/job_confirmation/interview_preview/published/company/:companyId/interviews/:id',
      name: 'bossSPublishedInterviewPreview',
      component: InterviewPreview
    },
    {
      path: '/boss_s/job_confirmation/interview_preview_sp/published/company/:companyId/interviews/:id',
      name: 'bossSPublishedInterviewPreviewSp',
      component: InterviewPreviewSp
    },
    {
      path: '/boss_s/job_confirmation/company_preview/editing/company/:id',
      name: 'bossSEditingCompanyPreview',
      component: CompanyPreview
    },
    {
      path: '/boss_s/job_confirmation/company_preview_sp/editing/company/:id',
      name: 'bossSEditingCompanyPreviewSp',
      component: CompanyPreviewSp
    },
    {
      path: '/boss_s/job_confirmation/company_preview/confirm/company/:id',
      name: 'bossSConfirmCompanyPreview',
      component: CompanyPreview
    },
    {
      path: '/boss_s/job_confirmation/company_preview_sp/confirm/company/:id',
      name: 'bossSConfirmCompanyPreviewSp',
      component: CompanyPreviewSp
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    // https://router.vuejs.org/ja/guide/advanced/scroll-behavior.html
    if (savedPosition) {
      return savedPosition
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  }
})
